<template>
  <v-dialog v-model="dialogApprove" persistent max-width="688px" :retain-focus="false">
      <v-card tile class="pt-4 pl-10 pr-10 pb-4">
        <v-divider
            inset
            vertical
          ></v-divider>
        <div class="">
          <span class="black--text font-weight-bold mr-5">ข้อมูลการอนุมัติ</span>
          <v-chip
            v-if="status=='pending'"
            small
            :color="'#ECF9FF'"
            text-color="#00B0FF"
          >
            <span>กำลังดำเนินการ</span>
          </v-chip>
          <v-chip
            v-else-if="status=='waiting'"
            small
            :color="'#FEF5E9'"
            text-color="#E9A016"
          >
            <span>รออนุมัติ</span>
          </v-chip>
          <v-chip
            v-else-if="status=='approve'"
            small
            :color="'#ECF8EA'"
            text-color="#58A144"
          >
            <span>อนุมัติแล้ว</span>
          </v-chip>
          <v-chip
            v-else-if="status=='acknowledge'"
            small
            :color="'#ECF8EA'"
            text-color="#58A144"
          >
            <span>รับทราบแล้ว</span>
          </v-chip>
          <v-chip
            v-else
            small
            :color="'#FBE5E4'"
            text-color="#D1392B"
          >
            <span>ไม่อนุมัติ</span>
          </v-chip>
          <v-btn absolute right top icon x-small @click="closeDialogApprove"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-divider class="mt-4 mb-4"/>
        <v-row style="margin-top: -14px;">
          <v-col cols="12" lg="5" md="6" sm="6">
            <pre class="ra-head-text-gray">หมายเลขคำร้อง</pre>
            <pre class="ra-head-text black--text">{{ reqEmployeeNo }}</pre>
          </v-col>
          <v-col cols="12" lg="7" md="6" sm="6">
            <pre class="ra-head-text-gray">ประเภทคำร้อง</pre>
            <pre class="ra-head-text black--text">{{ requestType }}</pre>
          </v-col>
          <v-col cols="12" lg="12" md="12" sm="12">
            <pre class="ra-head-text-gray">รายละเอียด</pre>
            <pre class="ra-head-text black--text  text-wrap">{{ detail }}</pre>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <pre class="ra-head-text-gray">ข้อมูลพนักงาน</pre>
          </v-col>
          <v-col cols="12">
            <v-card
              class="user-data-panel"
              style="margin-top: -14px;"
              outlined
            >
            <v-row class="pl-1 pr-1 pt-0">
                <v-col cols="12" sm="2" md="2" lg="2" class="">
                  <v-avatar
                    class="ml-3 mt-1"
                    :size="$vuetify.breakpoint.name !== 'lg'? '70':'70'"
                    rounded
                  >
                  <v-img
                    cover
                    :lazy-src="require('@/assets/icons/no_user.png')"
                    :src="this.userImg? this.userImg : require('@/assets/icons/no_user.png')"
                  >
                  </v-img>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="10" style="margin-top: -10px; margin-bottom: -10px;">
                  <v-row>
                    <v-col cols="12" lg="6" md="6" sm="6" v-if="employeeId && employeeId !== '-'">
                      <pre class="ra-head-text-gray">รหัสพนักงาน</pre>
                      <pre class="ra-head-text black--text">{{ employeeId }}</pre>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="6">
                      <pre class="ra-head-text-gray">ชื่อ - นามสกุล</pre>
                      <pre class="ra-head-text black--text">{{ employeeName }}</pre>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="6" v-if="lineofwork && lineofwork !== '-'">
                      <pre class="ra-head-text-gray">สายงาน</pre>
                      <pre class="ra-head-text black--text">{{ lineofwork }}</pre>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="6" v-if="department && department !== '-'">
                      <pre class="ra-head-text-gray">ฝ่ายงาน</pre>
                      <pre class="ra-head-text black--text">{{ department }}</pre>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="6" v-if="positionName && positionName !== '-'">
                      <pre class="ra-head-text-gray">ตำแหน่ง</pre>
                      <pre class="ra-head-text black--text">{{ positionName }}</pre>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <pre class="ra-head-text black--text font-weight-bold">ลำดับการอนุมัติ</pre>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-timeline
              class="user-data-panel"
              style="margin-top: -14px;"
              align-top
              dense
            >
              <v-timeline-item
                v-for="item in approveBy"
                :key="item.no"
                :color="item.statusApprove=='pending' || item.statusApprove=='waiting' ? '#E0EAFB':'#3776E9'"
                small
                fill-dot
              >
                <template v-slot:icon>
                  <span :class="item.statusApprove=='pending' || item.statusApprove=='waiting' ? 'blue--text':'white--text'">
                    {{ approveBy.indexOf(item)+1 }}
                  </span>
                </template>
                <v-row style="margin-top: -12px;">
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <pre class="ra-head-text font-weight-black">{{ item.approverName }}</pre>
                    <pre class="ra-head-text-gray">{{ item.email }}</pre>
                    <pre class="ra-head-text-gray">{{ item.positonName }}</pre>
                    <pre v-if="item.comment" class="ra-head-text black--text text-wrap" style="width: calc(100% + 0px);">ความเห็น : {{ item.comment }}</pre>
                    <pre v-else class="ra-head-text black--text"></pre>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <v-row class="ml-0">
                    <v-chip
                      v-if="item.statusApprove=='pending'"
                      small
                      :color="'#ECF9FF'"
                      text-color="#00B0FF"
                    >
                      <span>กำลังดำเนินการ</span>
                    </v-chip>
                    <v-chip
                      v-else-if="item.statusApprove=='waiting' && item.type=='approve'"
                      small
                      :color="'#FEF5E9'"
                      text-color="#E9A016"
                    >
                      <span>รออนุมัติ</span>
                    </v-chip>
                    <v-chip
                      v-else-if="item.type=='acknowledge' && item.statusApprove=='waiting'"
                      small
                      :color="'#FEF5E9'"
                      text-color="#E9A016"
                    >
                      <span>รอรับทราบ</span>
                    </v-chip>
                    <v-chip
                      v-else-if="item.type=='approve' && item.statusApprove=='approve'"
                      small
                      :color="'#ECF8EA'"
                      text-color="#58A144"
                    >
                      <span>{{ item.approveByAdmin? 'อนุมัติโดย แอดมิน':'อนุมัติแล้ว' }}</span>
                    </v-chip>
                    <v-chip
                      v-else-if="item.type=='acknowledge' && (item.statusApprove=='acknowledge' || item.statusApprove=='approve')"
                      small
                      :color="'#ECF8EA'"
                      text-color="#58A144"
                    >
                      <span>{{ item.approveByAdmin? 'รับทราบโดย แอดมิน':'รับทราบแล้ว' }}</span>
                    </v-chip>
                    <v-chip
                      v-else-if="item.statusApprove=='reject'"
                      small
                      :color="'#FBE5E4'"
                      text-color="#D1392B"
                    >
                      <span>{{ item.approveByAdmin? 'ไม่อนุมัติโดย แอดมิน':'ไม่อนุมัติ' }}</span>
                    </v-chip>
                    </v-row>
                    <v-row class="mt-4 ml-0" style="padding-left: 5px;">
                    <p class="ra-head-text-gray">
                      {{ item.approveDate? initDate(item.approveDate):''}}
                    </p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </v-row>
        <v-card-actions class="justify-center">
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-btn v-if="statusForApprove === 'pending' && mode ==='approve'" class="mr-0 create-orgchart-header-cancel-btn" color="red accent-2" dark @click="clickReject()">ไม่อนุมัติ</v-btn>
          <v-btn v-if="statusForApprove === 'pending' && mode ==='approve'" class="mr-0 create-orgchart-header-cancel-btn" color="green darken-2" dark @click="clickApprove()">อนุมัติ</v-btn>
          <v-btn v-if="statusForApprove === 'pending' && mode ==='acknowledge'" class="mr-0 create-orgchart-header-cancel-btn" color="green darken-2" dark @click="clickApprove()">รับทราบ</v-btn> -->
          <v-btn elevation="0" class="button-color head-search-button ml-1 white--text text--lighten-4" @click="closeDialogApprove">ปิด</v-btn>
        </v-card-actions>
      </v-card>
      <!-- <DialogTransferPermission/> -->
    </v-dialog>
</template>

<script>
import { EventBus } from '@/EventBus'
import { hostImageUrlv3 } from '@/API/API'
import swal from 'sweetalert'
import moment from 'moment'
import axios from 'axios'

export default {
  components: {
  },
  data () {
    return {
      mode: '',
      dialogApprove: false,
      id: '',
      reqEmployeeNo: '',
      requestType: '',
      detail: '',
      employeeName: '',
      accountId: '',
      employeeId: '',
      employeeTitle: '',
      positionName: '',
      userImg: '',
      orgChartId: '',
      lineofwork: '',
      statusForApprove: '',
      status: '',
      management: '',
      section: '',
      department: '',
      agency: '',
      groupwork: '',
      email: '',
      approveBy: [],
      dataSource: [],
      filterData: [],
      server: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      textCondition: {
        new: 'เพิ่มบุคคลเข้าทำงานในตำแหน่งงานใหม่',
        transfer: 'ขอย้ายฝ่ายเข้าทำงานในตำแหน่งงานใหม่',
        resign: 'ขอลาออก',
        transferPosition: 'ขอย้ายตำแหน่ง',
        resignPosition: 'ขอลาออกจากตำแหน่ง',
        resignEmployee: 'ลาออกจากบริษัท'
      },
      statusList: [
        { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#D1392B' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' }
      ]
    }
  },
  computed: {
    statusShow: function () {
      var filterStatus = this.status.filter(e => e.approverStatus === 'cancel')
      return filterStatus.length > 0 ? [filterStatus[0]] : this.status
    }
  },
  mounted () {
    EventBus.$on('openDialogManageApprove', this.getDetailRequest)
  },
  beforeDestroy () {
    EventBus.$off('openDialogManageApprove')
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    this.dataSource = []
  },
  methods: {
    closeDialogApprove () {
      this.dialogApprove = false
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    async getDetailRequest (role, item) {
      const self = this
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/manageEmployee/getDetailRequestEmployee`,
        method: 'POST',
        data: {
          requestId: item._id,
          role: role
        },
        headers: {
          authorization: this.$store.state.token
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            // console.log(response.data.result[0])
            response.data.result[0].id = response.data.result[0]._id
            this.status = response.data.result[0].requestStatus
            this.userImg = `${hostImageUrlv3}/_/${response.data.result[0].email}`
            Object.keys(response.data.result[0]).forEach(e => {
              if (e !== '_id') self[e] = response.data.result[0][e]
            })
            self.dialogApprove = true
          } else {
            self.dataSource = []
            self.dialogApprove = true
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
      this.loading = true
    },
    clickApprove () {
      swal(`ยืนยันการ ${this.mode === 'approve' ? 'Approve' : 'Acknowledge'} รายการที่เลือกใช่หรือไม่`, {
        content: {
          element: 'input',
          attributes: {
            placeholder: 'ความเห็น',
            type: 'text'
          }
        },
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      })
        .then((comment) => {
          if (comment) {
            this.updateStatusApprove(this.mode, comment)
          } else if (comment !== null && comment.trim() === '') {
            swal('', 'กรุณาระบุความเห็น', 'warning', {
              button: false,
              timer: 1000
            }).then(() => {
              this.clickApprove()
            })
          }
        })
    },
    clickReject () {
      swal('ยืนยันการ Reject รายการที่เลือกใช่หรือไม่', {
        content: {
          element: 'input',
          attributes: {
            placeholder: 'ความเห็น',
            type: 'text'
          }
        },
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      })
        .then((comment) => {
          if (comment) {
            this.updateStatusApprove('reject', comment)
          } else if (comment !== null && comment.trim() === '') {
            swal('', 'กรุณาระบุความเห็น', 'warning', {
              button: false,
              timer: 1000
            }).then(() => {
              this.clickReject()
            })
          }
        })
    },
    async updateStatusApprove (task, comment) {
      // console.log('updateStatusApprove')
      const self = this
      var confirmList = [
        {
          requestStatus: task,
          comment: comment,
          _id: self.id
        }
      ]
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/reqEmployee/updateStatusReqEmployee`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          approveList: confirmList
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
              button: false,
              timer: 2000
            })
            self.closeDialogApprove()
            EventBus.$emit('manageApproveSearch', this.filterData)
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}

img {
  width: 100%;
  height: auto;
  margin-top: -10%;
  /* position: absolute; */
  z-index: auto;
}

.v-timeline::before {
    top: 24px;
    height: calc(100% - 125px)
}
</style>
